import { cn } from '@/lib/tailwind-utils.js';
import {
  StudentGroupReassignmentRequestStatus,
  StudentGroupReassignmentRequestStatusLabelMap,
} from '@airreading/common/data';

type ReassignmentRequestDisplayStatusProps = {
  displayStatus: StudentGroupReassignmentRequestStatus;
};

const statusColorClassMap: Record<StudentGroupReassignmentRequestStatus, string> = {
  [StudentGroupReassignmentRequestStatus.requested]: 'text-orange-600',
  [StudentGroupReassignmentRequestStatus.processing]: 'text-blue-600',
  [StudentGroupReassignmentRequestStatus.resolved]: 'text-green-600',
};

export const ReassignmentRequestDisplayStatus = ({ displayStatus }: ReassignmentRequestDisplayStatusProps) => {
  return (
    <div className={cn('flex items-center gap-2', statusColorClassMap[displayStatus])}>
      <span className="w-2 h-2 rounded-full bg-current block" />
      <span>{StudentGroupReassignmentRequestStatusLabelMap[displayStatus]}</span>
    </div>
  );
};
